import * as React from 'react';
import { useHistory } from 'react-router';
import themePrimary from '../../styles/themePrimary';
import { Typography, makeStyles, Dialog, AppBar, IconButton, Toolbar } from '@material-ui/core';
import SmallButton, { SmallButtonProps } from '../common/Buttons/SmallButton';
import CloseIcon from '@material-ui/icons/Close';
import { String_FeedbackDialog_Title, 
    String_FeedbackDialog_Instruction, String_System_Cancel,
    String_System_Ok,
    String_ViewReceipt_SentThankYou,
    String_SendReceiptLink_SuccessMessage,
    String_System_No,
    String_System_Yes,
    String_System_CancelButton} from '../../utilities/StringHelper';
import { ElementDimensions } from '../../styles/ElementDimensions';
import { Skin } from '../../models/common/Skin';
import { UserStateContext } from '../../providers/UserStateContextProvider';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import SplitButtons, { SplitButtonProps } from '../common/Buttons/SplitButtons';

const useStyles = makeStyles({
    appBar: {
        position: 'relative',
        backgroundColor: props => (props as Skin).primary_main_color + ' !important',
    },
    buttonContainer: {
        padding: ElementDimensions.padding10 + 'px',
    },
    closeButton: {
        height: '30px',
        width: '30px',
        color: themePrimary.palette.primary.contrastText,
    },
    instructionText: {
        margin: ElementDimensions.margin10 + 'px',
        textAlign: 'center',
        fontFamily: 'LeagueSpartan-Regular !important',
    },
    root: {

    },
    rootLandscape: {
        left: '25vw !important',
        width: '50vw',
    },
    title: {
        marginLeft: ElementDimensions.margin10 + 'px',
        flex: 1,
        color: themePrimary.palette.primary.contrastText,
    },
});

export type FeedbackDialogCloseClickHandler = (event: React.MouseEvent<HTMLElement>) => any;
export type FeedbackDialogDoneClickHandler = (event: React.MouseEvent<HTMLElement>) => any;

export interface FeedbackDialogProps {
    open: boolean;
    receiptSent: boolean;
    onDoneHandler: FeedbackDialogDoneClickHandler;
    onCloseHandler: FeedbackDialogCloseClickHandler;
}

const FeedbackDialog = (props: FeedbackDialogProps) => {
    const { open, receiptSent, onDoneHandler, onCloseHandler } = props;
    const isPortrait = true;
    let history = useHistory();
    const userState = React.useContext(UserStateContext);
    const checkOutState = React.useContext(CheckOutStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });

    const handleClose = (event: React.MouseEvent<HTMLElement>) => {
        onCloseHandler(event);
    };

    const handleOkButtonClick = (event: React.MouseEvent<HTMLElement>) => {
        onDoneHandler(event);
    }

    const handleFeedbackNoButtonClick = (event: React.MouseEvent<HTMLElement>) => {
        onCloseHandler(event);
    }

    const handleFeedbackYesButtonClick = (event: React.MouseEvent<HTMLElement>) => {
        onDoneHandler(event);
    }

    const buttonProps: SmallButtonProps = {
        disabled: false,
        alternateColor: false,
        label: String_System_Ok.find(s => s.key === userState.state.locale)!!.value,
        onClickHandler: handleOkButtonClick,
    }

    const splitButtonProps: SplitButtonProps = {
            leftLabel: String_System_CancelButton.find(s => s.key === userState.state.locale)!!.value,
            rightLabel: String_System_Ok.find(s => s.key === userState.state.locale)!!.value,
            leftDisabled: false,
            rightDisabled: false,
            showIcons: false,
            useForwardIcon: false,
            useBackIcon: false,
            onLeftClickHandler: handleFeedbackNoButtonClick,
            onRightClickHandler: handleFeedbackYesButtonClick,
        }

    return (
        <Dialog open={open} onClose={handleClose} disableBackdropClick={true} className={isPortrait ? classes.root : classes.rootLandscape}>
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton  edge="start" color="inherit" onClick={handleClose} aria-label="close">
                        <CloseIcon className={classes.closeButton}/>
                    </IconButton>
                    <Typography variant="h6" className={classes.title}>
                        {receiptSent &&
                            String_ViewReceipt_SentThankYou.find(s => s.key === userState.state.locale)!!.value
                        }
                        {!receiptSent &&
                            String_FeedbackDialog_Title.find(s => s.key === userState.state.locale)!!.value
                        }
                    </Typography>
                </Toolbar>
            </AppBar>
            {receiptSent && 
                <Typography variant="h6" className={classes.instructionText}>
                    {String_SendReceiptLink_SuccessMessage.find(s => s.key === userState.state.locale)!!.value}
                </Typography>
            }
            <Typography variant="h6" className={classes.instructionText}>
                {String_FeedbackDialog_Instruction.find(s => s.key === userState.state.locale)!!.value}
            </Typography>
            <div className={classes.buttonContainer}>
                <SplitButtons
                    leftLabel={splitButtonProps.leftLabel}
                    rightLabel={splitButtonProps.rightLabel}
                    leftDisabled={splitButtonProps.leftDisabled}
                    rightDisabled={splitButtonProps.rightDisabled}
                    showIcons={splitButtonProps.showIcons}
                    useForwardIcon={splitButtonProps.useForwardIcon}
                    useBackIcon={splitButtonProps.useBackIcon}
                    onLeftClickHandler={splitButtonProps.onLeftClickHandler}
                    onRightClickHandler={splitButtonProps.onRightClickHandler} />
            </div>
        </Dialog>
    );
};

export default FeedbackDialog;